"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var context_1 = require("../context");
function useDoc(props) {
    var path = props.path;
    var app = react_1.useContext(context_1.default).app;
    var _a = react_1.useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = react_1.useState(null), data = _b[0], setData = _b[1];
    if (app) {
        react_1.useEffect(function () {
            var ref = app.firestore().doc(path);
            setIsLoading(true);
            var unsubscribe = ref.onSnapshot(function (doc) {
                if (doc.exists) {
                    setData({
                        id: doc.id,
                        data: doc.data(),
                    });
                }
                setIsLoading(false);
            });
            return function () {
                return unsubscribe();
            };
        }, [props.path]);
    }
    return [data, isLoading];
}
exports.default = useDoc;
//# sourceMappingURL=useDoc.js.map